// @ts-ignore
import { combineReducers } from 'redux';
import wizard from './wizard';

export interface ReduxState {
    wizard: any;
}

export default (history:any) =>
    combineReducers({
        wizard
    } as ReduxState);
